// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"545":"1df9853e","554":"c2b6b11d","760":"5ba2db5d","804":"a3110b32","815":"4a903754","918":"e3990309"}[chunkId] + ".chunk.js";
};